var swipers = {};
var adManager = {
	init: function() {
		$('.swiper-an').each(function(i) {
			$(this).addClass(`swiper-${i}`);
			let options = {};

			if ($(this).find(`.swiper-slide`).length > 1) {
				options = {
					effect: 'fade',
					preloadImages: false,
					lazy: true,
					fadeEffect: { crossFade: true },
					simulateTouch: false,
					observer: true,
					observeParents: true,
					allowTouchMove: false,
					loop: true,
					autoplay: {
						delay: 10000
					},
					on: {
						beforeInit: function() {
							adManager.checkCategory(`swiper-${i}`);
						},
						observerUpdate: function() {
							this.loopFix();
						}
					}
				};
			} else {
				options = {
					lazy: true,
					simulateTouch: false,
					loop: false,
					observer: true,
					allowTouchMove: false,
					observeParents: true,
					on: {
						beforeInit: function() {
							adManager.checkCategory(`swiper-${i}`);
						},
						observerUpdate: function() {
							// this.loopFix();
						}
					}
				};
			}
			if ($(this).hasClass('.swiper-container-initialized') === false) {
				swipers['swiper' + i] = new Swiper($(this), options);
				// console.log(swipers);
			}
		});
	},
	update: function() {
		if (swipers) {
			$.each(swipers, function(i, value) {
				// console.log(value);
				value.destroy();
			});
		}
		adManager.checkCategory();
	},
	checkCategory: function(swiper = null) {
		var categoria = $('.an-categoria').val();
		var execute = function(slide) {
			var link = adManager.linkFix(slide.find('a').attr('href'));
			slide.find('a').attr('href', link);
			var cat = slide.data('cat').split(',');

			if ($.isNumeric(categoria) === true) {
				if (adManager.arrayContains('allnews', cat) || adManager.arrayContains('all', cat)) {
					slide.show();
				} else if (!adManager.arrayContains(categoria, cat)) {
					slide.remove();
					slide.hide();
				}
			} else {
				if (!adManager.arrayContains(categoria, cat) && cat[0] != 'all') {
					slide.hide();
				} else {
					slide.show();
				}
			}
		};
		if (swiper) {
			$(`.${swiper} .swiper-slide`).each(function(i, v) {
				execute($(this));
			});
		} else {
			$(`.swiper-an`).each(function(i, v) {
				let $this = $(this);
				$this.find('.swiper-slide').each(function(index, value) {
					execute($(this));
				});
			});
		}
	},
	// HELPERS
	linkFix: function(link) {
		var pattern = new RegExp('^(https?|ftp)://');

		if (!pattern.test(link) && !link.includes('javascript')) {
			return (link = 'http://' + link);
		}
	},
	arrayContains: function(keyword, array) {
		return array.indexOf(keyword) > -1;
	}
};
$(() => {
	adManager.init();
});
